module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.required && !_vm.field.hide
      }),
      expression: "{required: required && !field.hide}"
    }],
    staticClass: "tim form-control",
    attrs: {
      "id": _vm.field.name,
      "name": _vm.field.name,
      "data-vv-as": _vm.field.description.replace(/\./g, ''),
      "type": "text",
      "data-provide": "timepicker",
      "data-default-time": _vm.value || 'current',
      "readonly": _vm.locked
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e263b36","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/render/TimeRender.vue
// module id = 1721
// module chunks = 1